/**
 * @Author: Zero
 * @Date: 2026-06-09 10:38:09
 * @Explain: 邀请用户邮件接受邀请验证页面（未登录可直接访问）
 */
import httpApiv2 from '../http-apiv2';

const MODEL = '/invite';

export default {
  // 校验邀请信息
  onCheckInvited(data: Record<any, any>) {
    return httpApiv2.post(`${MODEL}/check`, data);
  },
};
